module.exports = __webpack_public_path__ + "img/press-bg.086a270f.jpeg";